export const AI_SETTING_RESPONSE_MODE_TUTORIAL_URL = "https://tutorials.1convo.ai/getstarted/botsetting/response-mode";
